import React, { useRef, useEffect, useState } from 'react';
import { Paper, Button, IconButton } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

import { numberWithCommas } from '../../../../../../utils/numberWithCommas';
import styles from './ModelInfo.module.scss';
import { connect } from 'react-redux';

const ModelInfo = (props) => {
	const {
		buildingInfo,
		modelId,
		closeModelInfoModal,
		setModelId,
		setElevationId,
		openModelInfoDetailModal,
		lotSelectedId,
		fitLots,
	} = props;

	const [elevationList, setElevationList] = useState([]);

	useEffect(() => {
		if (lotSelectedId) {
			let filtered = buildingInfo[modelId]?.priceList.filter((item) => {
				let filteredFitLots = fitLots.filter(
					(fitLot) => fitLot[modelId]
				);
				if (filteredFitLots.length > 0) {
					let elevationObj = filteredFitLots[0][modelId];

					if (
						item?.id &&
						elevationObj[item.id] &&
						elevationObj[item.id].includes(Number(lotSelectedId))
					) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			});
			setElevationList(filtered);
		} else {
			setElevationList(buildingInfo[modelId]?.priceList);
		}
	}, [lotSelectedId, buildingInfo, modelId, fitLots]);

	const modelListRef = useRef(null);

	const handleClickDetails = (modelId, elevationId) => {
		setModelId(modelId);
		setElevationId(elevationId);
		closeModelInfoModal();
		openModelInfoDetailModal();
	};

	const handleNav = (direction) => {
		if (direction === 'left') {
			if (modelListRef) {
				modelListRef.current.scrollLeft -= 200;
			}
		} else {
			if (modelListRef) {
				modelListRef.current.scrollLeft += 200;
			}
		}
	};

	return (
		<div className={styles.model_info}>
			<div className={styles.model_list} ref={modelListRef}>
				{!lotSelectedId &&
					buildingInfo[modelId]?.priceList.map((item, index) => (
						<Paper className={styles.model} key={index}>
							<img
								src={
									item.images
										? item.images[0].url
										: 'https://via.placeholder.com/290x200?text=No+Images'
								}
							/>
							<h3>
								{modelId} {item.id}
							</h3>
							<p>{`Total $${numberWithCommas(
								Number(item?.price)
							)}`}</p>
							<Button
								variant='outlined'
								className={styles.model_btn}
								onClick={() =>
									handleClickDetails(modelId, item.id)
								}
							>
								Details
							</Button>
						</Paper>
					))}
				{lotSelectedId &&
					buildingInfo[modelId]?.priceList
						.filter((item) => {
							let filteredFitLots = fitLots.filter(
								(fitLot) => fitLot[modelId]
							);
							if (filteredFitLots.length > 0) {
								let elevationObj = filteredFitLots[0][modelId];

								if (
									item?.id &&
									elevationObj[item.id] &&
									elevationObj[item.id].includes(
										Number(lotSelectedId)
									)
								) {
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						})
						.map((item, index) => (
							<Paper className={styles.model} key={index}>
								<img
									src={
										item.images
											? item.images[0].url
											: 'https://via.placeholder.com/290x200?text=No+Images'
									}
								/>
								<h3>
									{modelId} {item.id}
								</h3>
								<p>{`Total $${numberWithCommas(
									Number(item?.price)
								)}`}</p>
								<Button
									variant='outlined'
									className={styles.model_btn}
									onClick={() =>
										handleClickDetails(modelId, item.id)
									}
								>
									Details
								</Button>
							</Paper>
						))}
			</div>
			{elevationList?.length > 1 && (
				<div className={styles.nav_btn_group}>
					<IconButton
						size='small'
						className={styles.prev_btn}
						onClick={() => handleNav('left')}
					>
						<NavigateBeforeIcon />
					</IconButton>
					<IconButton
						size='small'
						className={styles.next_btn}
						onClick={() => handleNav('right')}
					>
						<NavigateNextIcon />
					</IconButton>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
	fitLots: state.siteplanManagement.fitLots,
});

export default connect(mapStateToProps)(ModelInfo);
